import { useTranslation } from 'react-i18next'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { FormControl, FormHelperText, Typography, Switch } from '@mui/material'

type SwitchProps = {
    onChange?: (enabled: boolean) => void
    label?: string
    labelOn?: string
    labelOff?: string
    checked: boolean
    disabled?: boolean
    required?: boolean
    helperText?: string
    width?: number
    height?: number
    fontSize?: number
    labelTop?: number
    labelLeft?: number
    labelRight?: number
}

const SwitchControl = (props: SwitchProps) => {
    const {
        onChange,
        checked = true,
        label = '',
        labelOn = 'On',
        labelOff = 'Off',
        helperText,
        width = 50,
        height = 24,
        fontSize = 12,
        labelTop = 3,
        labelLeft = 7,
        labelRight = 7,
        disabled = false,
        required = false,
    } = props
    const classes = useStyles({
        checked,
        labelOn,
        labelOff,
        width,
        height,
        fontSize,
        labelTop,
        labelLeft,
        labelRight,
        disabled,
    })
    const { t } = useTranslation()

    return (
        <div style={{ width: '100%' }}>
            <FormControl>
                {label && (
                    <Typography>
                        {label} {!disabled && required && <label style={{ color: '#d32f2f' }}>{' *'}</label>}
                    </Typography>
                )}
                <Switch
                    classes={{
                        root: classes.root,
                        switchBase: classes.switchBase,
                        thumb: classes.thumb,
                        track: classes.track,
                        checked: classes.checked,
                    }}
                    checked={checked}
                    onChange={() => {
                        onChange?.(!checked)
                    }}
                    disabled={disabled}
                />
                <FormHelperText>
                    <label style={{ color: '#d32f2f' }}>
                        {!disabled
                            ? required && !checked
                                ? t('LABEL.SELECT_REQUIRED')
                                : helperText
                                ? helperText
                                : ''
                            : ''}
                    </label>
                </FormHelperText>
            </FormControl>
        </div>
    )
}

export default SwitchControl

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        width: (props: any) => `${props.width}px !important`,
        height: (props: any) => `${props.height}px !important`,
        padding: '0px !important',
    },
    switchBase: {
        color: '#9A9A9A !important',
        padding: '1px !important',
        '&$checked': {
            '& + $track': {
                backgroundColor: `${theme.palette.primary.main} !important`,
            },
        },
    },
    thumb: {
        color: `${theme.palette.text.secondary} !important`,
        width: (props: any) => `${props.height - 4}px !important`,
        height: (props: any) => `${props.height - 4}px !important`,
        margin: '1px',
    },
    track: {
        borderRadius: (props: any) => `${props.height - 4}px !important`,
        backgroundColor: '#9A9A9A !important',
        opacity: (props: any) => `${props.disabled ? 0.5 : 1} !important`,
        '&:after, &:before': {
            color: `${theme.palette.text.secondary} !important`,
            fontSize: (props: any) => `${props.fontSize}px !important`,
            position: 'absolute',
            top: (props: any) => `${props.labelTop}px !important`,
        },
        '&:after': {
            content: (props: any) => (props.checked ? `'${props.labelOn}'` : "''"),
            left: (props: any) => `${props.labelLeft}px !important`,
        },
        '&:before': {
            content: (props: any) => (!props.checked ? `'${props.labelOff}'` : "''"),
            right: (props: any) => `${props.labelRight}px !important`,
        },
    },
    checked: {
        color: `${theme.palette.primary.main} !important`,
        transform: (props: any) => `translateX(${props.width - 24}px) !important`,
    },
}))
